import SubHeaderBar from './SubHeaderBar.connect';
import * as SubHeaderBarSelectors from './SubHeaderBar.selectors';

SubHeaderBar.selectors = SubHeaderBarSelectors;
export default SubHeaderBar;
